import { render, staticRenderFns } from "./edit-button.vue?vue&type=template&id=415a2608&scoped=true"
import script from "./edit-button.vue?vue&type=script&lang=js"
export * from "./edit-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a2608",
  null
  
)

export default component.exports